//Removes rogue <p> and <span> tags from text that comes from the API.
export const textCleanup = text => text.replace(/(<\/?((p)|(span))( class="[a-zA-Z]*")?>)/g, '')
